module.exports = __webpack_public_path__ + "images/path-arrow.6811da641e7f3a98e10d4e87351758d4.svg";